export interface SuspiciousActivityReport {
  yukumlu: FieldData;
  temelBilgi: {
    label: string;
    value: {
      bildirimKategorisi: FieldData;
      yerelReferansNo: FieldData;
      oncekiBildirimReferansNo: FieldData;
      aciliyet: FieldData;
      terorOrgutu: FieldData;
    };
    type: FieldType;
  };
  supheliIslem: {
    label: string;
    value: {
      islemCesidi: FieldData;
      islemTarihi1: FieldData;
      islemTarihi2: FieldData;
      islemDurumu: FieldData;
      hesabaBagli: FieldData;
      tutarTP: FieldData;
      tutar: FieldData;
      paraBirimi: FieldData;
      islemTuru: FieldData;
      islemKanali: FieldData;
      ipv4: FieldData;
      port: FieldData;
      islemAciklamasi: FieldData;
      ulkeKodu: FieldData;
      ilKodu: FieldData;
      ilceKodu: FieldData;
      isleminGerceklestigiYer: FieldData;
      isleminTetiklendigiYer: FieldData;
      islemeAracilikEtmeDurumu: FieldData;
      islemeAracilikEdenKurum: FieldData;
    };
    type: FieldType;
  };
  hesap: {
    label: string;
    value: {
      sahisFirmasiHesabi: FieldData;
      hesapTuru: FieldData;
      hesapNo: FieldData;
      iban: FieldData;
      acilisTarihi: FieldData;
      kapanisTarihi: FieldData;
      sonIslemTarihi: FieldData;
      bakiyeTP: FieldData;
      bakiye: FieldData;
      paraBirimi: FieldData;
      kisitlamaTuru: FieldData;
      kisitlamaDigerAciklama: FieldData;
      hesapSahibi: {
        label: string;
        value: {
          magdur: FieldData;
          adSoyadUnvan: FieldData;
          tckn: FieldData;
          vkn: FieldData;
          ykn: FieldData;
          passaport: FieldData;
        };
        type: FieldType;
      };
    };
    type: FieldType;
  };
  supheKategorisi: FieldData;
  bildirimAciklama: FieldData;
  gercekKisi: {
    label: string;
    value: {
      islemleBaglantisi: FieldData;
      islemleBaglantisiAciklama: FieldData;
      adi: FieldData;
      soyadi: FieldData;
      tckn: FieldData;
      vkn: FieldData;
      ykn: FieldData;
      dogumTarihi: FieldData;
      dogumYeri: FieldData;
      anaAdi: FieldData;
      babaAdi: FieldData;
      uyrugu: FieldData;
      cinsiyeti: FieldData;
      kimlikBelgesi: {
        label: string;
        value: {
          belgeTuru: FieldData;
          belgeNumarasi: FieldData;
          gecerlilikTarihi: FieldData;
        };
        type: FieldType;
      };
      meslek: FieldData;
      ekBilgi: FieldData;
      adres: {
        label: string;
        value: {
          adresSatir: FieldData;
          postaKodu: FieldData;
          ilKodu: FieldData;
          ilceKodu: FieldData;
          ulkeKodu: FieldData;
        };
        type: FieldType;
      };
      iletisimBilgisi: FieldData;
      kimlikBilgileriSahte: FieldData;
      magdur: FieldData;
      kimlikTespitTuruTip: FieldData;
    };
    type: FieldType;
  };
  digerKisi: {
    label: string;
    value: {
      islemleBaglantisi: FieldData;
      islemleBaglantisiAciklama: FieldData;
      kurulusNevi: FieldData;
      unvan: FieldData;
      isletmeAdi: FieldData;
      vkn: FieldData;
      sicilNo: FieldData;
      faaliyetKonusu: FieldData;
      ulkeKodu: FieldData;
      ilKodu: FieldData;
      ilceKodu: FieldData;
      kurulusTarihi: FieldData;
      websitesi: FieldData;
      ekBilgi: FieldData;
      adres: {
        label: string;
        value: {
          adresSatir: FieldData;
          postaKodu: FieldData;
          ilKodu: FieldData;
          ilceKodu: FieldData;
          ulkeKodu: FieldData;
        };
        type: FieldType;
      };
      iletisimBilgisi: FieldData;
      kimlikBilgileriSahte: FieldData;
      magdur: FieldData;
    };
    type: FieldType;
  };
}

export interface FieldData {
  value: any;
  label: string;
  type: FieldType;
  staticVisible?: boolean;
  staticValue?: string;
  conditions?: string[];
  additionalInfo?: string;
}

export interface CustomFields {
  yukumlu: string;
  bildirimKategorisi: string;
  yerelReferansNo: string;
  oncekiBildirimReferansNo: string;
  aciliyet: string;
  terorOrgutu: string;
  bildirimAciklama: string;
}

export enum FieldType {
  ZORUNLU = 'ZORUNLU',
  OPSIYONEL = 'OPSIYONEL',
  KOSULLU_ZORUNLU = 'KOSULLU_ZORUNLU',
}
